import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isOpen) = $event)),
    title: "Choisissez votre mode de paiement",
    "previous-display": _ctx.wizardStep !== 0,
    onPrevious: _ctx.back,
    actions: _ctx.dialogActions,
    prefixDataCy: "ConfigurePaymentModeDialog",
    "min-width": "40vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.wizardStep,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.wizardStep) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: option.value,
                      onClick: ($event: any) => (_ctx.selectPaymentMethod(option.value)),
                      ripple: "",
                      class: "oss-list-item-xl mb-2 py-3",
                      "data-cy": `PaymentModeWizard-paymentModeOption-${option.value}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "data-cy"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              (_ctx.selectedPaymentMethod === 'check')
                ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                    key: 0,
                    label: "Information complémentaire",
                    modelValue: _ctx.paymentModeDetails,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentModeDetails) = $event)),
                    "data-cy": "LegalForm-paymentMode-details-check"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.selectedPaymentMethod === 'direct_debit')
                ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                    key: 1,
                    label: "Information complémentaire",
                    modelValue: _ctx.paymentModeDetails,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paymentModeDetails) = $event)),
                    "data-cy": "LegalForm-paymentMode-details-debit"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.selectedPaymentMethod === 'bank_transfer')
                ? (_openBlock(), _createBlock(_component_v_select_filled, {
                    key: 2,
                    label: "Sélectionnez un compte bancaire",
                    modelValue: _ctx.paymentModeDetails,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paymentModeDetails) = $event)),
                    items: _ctx.formattedBankAccounts,
                    "item-title": "name",
                    "item-value": "iban",
                    "data-cy": "PaymentModeWizard-bankTransferDetails"
                  }, {
                    item: _withCtx(({ props, item }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        subtitle: item.raw.iban
                      }), null, 16, ["subtitle"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              (_ctx.selectedPaymentMethod === 'other')
                ? (_openBlock(), _createBlock(_component_v_textarea_filled, {
                    key: 3,
                    label: "Instructions personnalisées",
                    modelValue: _ctx.paymentModeDetails,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paymentModeDetails) = $event)),
                    "data-cy": "LegalForm-paymentMode-details-other"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "previous-display", "onPrevious", "actions"]))
}